export const REVEAL_TIME_MS = 120